export default __webpack_public_path__ + "static/media/405.2771267c.jpg";